import backArrow from '../../../../../assets/img/backArrow.png';
import { useState, useEffect, useContext } from 'react';
import { GlobalContext } from 'GlobalContext';
import { USDollar, parsePgArray } from 'utils/format';
import api from 'api';
import { get } from 'utils/fetch';
import { message, Spin, Input, Select, InputNumber } from 'antd';
import { enumOptions } from 'pages/AssetManager/AssetManagerContext';
import { isPhoneSize } from 'utils/util';

export function RentalDetailed() {
    const { manageAssetId, accessToken, assetManager, refreshSession } =
        useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const { rentalId, setRentalId } = assetManager;

    const [rentalStatus, setRentalStatus] = useState([]);
    const [monthlyRent, setMonthlyRent] = useState(0);
    const [unit, setUnit] = useState('');
    const [leaseStartDate, setLeaseStartDate] = useState(null);
    const [leaseExpireDate, setLeaseExpireDate] = useState(null);

    const [loading, setLoading] = useState(rentalId === -1 ? false : true);
    const [rental, setRental] = useState(null);
    const [editMode, setEditMode] = useState(false);

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchRentalInfo(rentalId) {
        await get(
            api.asset.getRental(rentalId),
            setRental,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    function restore() {
        setRentalStatus(parsePgArray(rental.rental_status));
        setMonthlyRent(rental.monthly_rent);
        setUnit(rental.unit);
        setLeaseStartDate(rental.lease_start_date);
        setLeaseExpireDate(rental.lease_expire_date);
    }

    useEffect(() => {
        if (rental) {
            restore();
        }
    }, [rental]);

    useEffect(() => {
        if (rentalId <= 0) {
            return;
        }
        fetchRentalInfo(rentalId);
    }, [rentalId]);

    useEffect(() => {
        if (rentalId === -1) {
            setEditMode(true); // auto-enable editing when adding
        } else {
            setEditMode(false); // disable editing until user clicks "Edit"
        }
    }, [rentalId]);

    function unchanged() {
        if (rentalId === -1) {
            return false;
        }
        return (
            rentalStatus === rental.rental_status &&
            monthlyRent === rental.monthly_rent &&
            unit === rental.unit &&
            leaseStartDate === rental.lease_start_date &&
            leaseExpireDate === rental.lease_expire_date
        );
    }

    async function upsert() {
        if (unchanged()) return;
        setLoading(true);
        const body = JSON.stringify({
            manageAssetId,
            rentalStatus,
            monthlyRent,
            unit,
            leaseStartDate,
            leaseExpireDate,
        });

        const options = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body,
        };
        const response = await fetch(api.asset.upsertRental(rentalId), options);
        const data = await response.json();
        const idRes = data.data;
        refreshSession();

        if (idRes === 0) {
            messageApi.error({
                type: 'error', // or 'error', 'info', 'warning', 'loading'
                content:
                    rentalId === -1
                        ? 'Rental insertion failed'
                        : 'Rental update failed',
                duration: 3, // seconds (optional)
            });
            setRentalId(0);
        } else {
            messageApi.open({
                type: 'success', // or 'error', 'info', 'warning', 'loading'
                content:
                    rentalId === -1
                        ? 'Rental insertion success'
                        : 'Rental update success',
                duration: 3, // seconds (optional)
            });
            setRentalId(idRes);
            fetchRentalInfo(idRes);
        }
        setEditMode(false);
    }

    async function deleteRental() {
        setLoading(true);

        const options = {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const response = await fetch(api.asset.deleteRental(rentalId), options);
        const data = await response.json();
        const idRes = data.data;
        refreshSession();

        if (idRes === 0) {
            messageApi.error({
                type: 'error',
                content: 'Loan deletion failed',
                duration: 3,
            });
        } else {
            messageApi.open({
                type: 'success',
                content: 'Loan deletion success',
                duration: 3,
            });
            setRentalId(0);
        }
    }

    function firstElement(list) {
        if (list === null || list === undefined) {
            return null;
        }
        return list[0];
    }

    const entryStyle = {
        margin: '20px',
        fontSize: '20px',
    };

    const inputStyle = {
        border: '0',
        outline: 'none',
        borderBottom: '1px solid black',
        fontSize: '20px',
        background: 'transparent',
    };

    return (
        <>
            {contextHolder}
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && (
                <>
                    <div
                        style={{
                            display: 'flex',
                            marginLeft: '20px',
                            position: 'fixed',
                            background: 'white',
                            width: '100%',
                            zIndex: 1,
                            height: '40px',
                            alignItems: 'end',
                        }}
                    >
                        <img
                            style={{
                                width: '15px',
                                height: '20px',
                                cursor: 'pointer',
                            }}
                            src={backArrow}
                            onClick={() => {
                                setRentalId(0);
                            }}
                        ></img>
                        {rentalId !== -1 && (
                            <div
                                style={{
                                    width: 'fit-content',
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    marginLeft: '20px',
                                }}
                                onClick={() => {
                                    if (editMode) {
                                        restore();
                                    }
                                    setEditMode((prev) => !prev);
                                }}
                            >
                                {editMode ? 'Restore' : 'Edit'}
                            </div>
                        )}
                    </div>

                    <div style={{ fontSize: '18px' }}>
                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : {
                                          ...entryStyle,
                                          display: 'flex',
                                          marginTop: '60px',
                                      }
                            }
                        >
                            <div>Rental Status: </div>
                            {editMode ? (
                                <Select
                                    showSearch
                                    placeholder="Select a status"
                                    value={firstElement(rentalStatus)}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    style={{ width: '200px' }}
                                    onChange={(e) => setRentalStatus([e])}
                                    options={enumOptions['Rental Status'].map(
                                        (status) => {
                                            return {
                                                value: status.toLowerCase(),
                                                label: status,
                                            };
                                        }
                                    )}
                                />
                            ) : (
                                <div>{rentalStatus}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Monthly Rent: </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        outline: 'none',
                                        border: 'none',
                                        borderBottom: '1px solid black',
                                        width: 'auto', // optional, can adjust
                                    }}
                                    value={monthlyRent}
                                    onChange={(value) => setMonthlyRent(value)} // value is already numeric or null
                                    placeholder="Monthly rent"
                                    controls={false} // hides up/down arrows
                                />
                            ) : (
                                <div>{USDollar.format(monthlyRent)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Lease Start Date: </div>
                            {editMode ? (
                                <input
                                    type="date"
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    value={leaseStartDate || ''}
                                    onChange={(e) =>
                                        setLeaseStartDate(e.target.value)
                                    }
                                ></input>
                            ) : (
                                <div>{leaseStartDate}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Lease Expire Date: </div>
                            {editMode ? (
                                <input
                                    type="date"
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    value={leaseExpireDate || ''}
                                    onChange={(e) =>
                                        setLeaseExpireDate(e.target.value)
                                    }
                                ></input>
                            ) : (
                                <div>{leaseExpireDate}</div>
                            )}
                        </div>
                    </div>

                    <button
                        style={{
                            height: '30px',
                            width: '60px',
                            borderRadius: '30px',
                            background: 'rgb(17 32 86)',
                            color: 'white',
                            cursor: 'pointer',
                            marginLeft: '20px',
                        }}
                        onClick={upsert}
                    >
                        Save
                    </button>
                    <button
                        style={{
                            height: '30px',
                            width: '60px',
                            borderRadius: '30px',
                            background: 'rgb(86 17 17)',
                            color: 'white',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            if (
                                window.confirm(
                                    'Are you sure you want to delete this rental?'
                                )
                            ) {
                                deleteRental();
                            }
                        }}
                    >
                        Delete
                    </button>
                </>
            )}
        </>
    );
}
